import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  tr: {
    whiteSpace: 'nowrap',
  },
}

const Tr = ({ classes, className, children }) => (
  <tr className={classNames(classes.tr, className)}>{children}</tr>
)

export default injectStyles(styles)(Tr)
